import { useEffect } from 'react';
import { homeHubs, useLayout } from '../layout';
import { linkProps, navigate } from '../router';
import { WidgetView } from '../components/Widgets';
export { PlayIcon } from '../components/Icons';

/**
 * Home en andere hubs. De widgets en hun volgorde komen uit de indeling
 * (Instellingen → Startscherm aanpassen); per profiel kan die anders zijn.
 */
export function Home({ hubId }: { hubId?: string }) {
  const layout = useLayout();
  const allHubs = layout?.hubs ?? [];
  const hubs = homeHubs(layout);
  // Een hub die niet op Home staat, is via /hub/:id wel te openen
  const hub = allHubs.find((h) => h.id === hubId) ?? allHubs[0];

  // Onbekende hub (bijv. verwijderd): terug naar de eerste
  useEffect(() => {
    if (layout && hubId && !allHubs.some((h) => h.id === hubId)) navigate('/', { replace: true });
  }, [layout, hubId, allHubs]);

  if (!layout || !hub) return <main aria-busy="true" className="page"><div className="row-skeleton" style={{ margin: '0 var(--gutter)' }} /></main>;

  const widgets = hub.widgets.filter((w) => w.enabled);
  const first = widgets[0];

  return (
    <main className={first && ['spotlight', 'billboard'].includes(first.view) ? 'hub has-spotlight' : 'hub'}>
      {hubs.length > 1 && (
        <nav className={`hub-switcher${hubs.some((h) => h.cover?.image || h.cover?.color) ? ' has-covers' : ''}`} aria-label="Hubs">
          {hubs.some((h) => h.cover?.image || h.cover?.color) ? (
            <div className="hub-covers" data-focus-group>
              {hubs.map((h, i) => (
                <a key={h.id} className="hub-cover" {...linkProps(i === 0 ? '/' : `/hub/${h.id}`)} aria-current={h.id === hub.id ? 'page' : undefined}
                  style={{ backgroundColor: h.cover?.color, backgroundImage: h.cover?.image ? `url("${h.cover.image}")` : undefined }}>
                  <span>{h.cover?.icon && <i aria-hidden="true">{h.cover.icon}</i>}{h.name}</span>
                </a>
              ))}
            </div>
          ) : (
            <div className="hub-pills" data-focus-group>
              {hubs.map((h, i) => (
                <a key={h.id} className="hub-pill" {...linkProps(i === 0 ? '/' : `/hub/${h.id}`)} aria-current={h.id === hub.id ? 'page' : undefined}>
                  {h.cover?.icon && <span aria-hidden="true">{h.cover.icon} </span>}{h.name}
                </a>
              ))}
            </div>
          )}
        </nav>
      )}
      {widgets.length === 0 && (
        <div className="empty-card">
          <h2>Deze hub is nog leeg</h2>
          <a className="btn btn-primary" {...linkProps('/settings/home')}>Widgets toevoegen</a>
        </div>
      )}
      {widgets.map((w) => <WidgetView key={w.id} w={w} />)}
      <div className="footer-space" />
    </main>
  );
}
